export const LOADING_PRODUCT_UPDATE_EVENTS_SUCCESS = 'LOADING_PRODUCT_UPDATE_EVENTS_SUCCESS';
export const LOADING_PRODUCT_UPDATE_EVENTS_ERROR = 'LOADING_PRODUCT_UPDATE_EVENTS_ERROR';
